import React from 'react';
import './DetailedHistory.css';

function DetailedHistoryEn() {
  return (
    <section className="detailed-history-section">
      <div className="container">
        <div className="detailed-history-content">
          <h2 className="detailed-history-title">The History of Tabia Group</h2>
          
          <p className="history-paragraph">
            Tabia Group is a diversified asset and business holding company, with a main focus —though not exclusive— on the real estate sector. The company was born in the Balearic Islands, a location historically linked to investment and real estate assets, and from its origins has adopted a clear national and international vocation.
          </p>
          
          <p className="history-paragraph">
            With a strong presence in the Iberian Peninsula and investment activity that transcends borders, Tabia Group has provided advice on real estate investments in more than nine countries, accompanying private investors, family offices and corporate structures in making strategic decisions with high asset impact.
          </p>
          
          <p className="history-paragraph">
            The group structures its activity through three complementary business lines, designed to cover the entire value cycle of real estate assets:
          </p>
          
          <ul className="business-lines">
            <li>
              <strong>Real estate investment,</strong> focused on identifying, structuring and executing opportunities with high profitability potential and value preservation.
            </li>
            <li>
              <strong>Real estate asset management,</strong> developed through TABIA Management, aimed at optimization, control and efficient growth of real estate portfolios.
            </li>
            <li>
              <strong>Real estate brokerage,</strong> channeled through TABIA Real Estate, specialized in identifying and structuring real estate asset purchase and sale operations, with a strategic, discreet and highly professionalized approach.
            </li>
          </ul>
          
          <p className="history-paragraph">
            Currently, Tabia Group manages a real estate portfolio valued at more than 390 million euros, reflecting its ability to design comprehensive, solid solutions aligned with the interests of clients and investors, combining strategic vision, deep market knowledge and rigorous execution.
          </p>
          
          <p className="history-paragraph">
            At the helm of the company is David Pons, president of Tabia Group, a young entrepreneur and investor with a career forged from a very early age in the real estate sector. His ability to identify opportunities, structure investments and anticipate market cycles has been key in consolidating the group as a trusted partner for national and international investors.
          </p>
          
          <p className="history-paragraph closing-paragraph">
            Today, Tabia Group represents a way of understanding real estate investment based on discipline, long-term vision and sustainable value creation, positioning itself as a relevant player in the Spanish real estate landscape with a solid international projection.
          </p>
        </div>
      </div>
    </section>
  );
}

export default DetailedHistoryEn;
